Math.fmod = function (a, b) {
  return Number((a - (Math.floor(a / b) * b)).toPrecision(8))
}

export default {
  name: 'Helpers',
  methods: {
    camelize: function (str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase()
      }).replace(/\s+/g, '')
    },
    capitalizeFirstLetter: function (str) {
      if (typeof str === 'string' && str.length > 1) {
        return str[0].toUpperCase() + str.slice(1).toLowerCase()
      }
      return str
    },
    rad: function (x) {
      return x * Math.PI / 180
    },
    deg: function (x) {
      return x / Math.PI * 180
    },
    makeRandomHash: function (length) {
      let result = ''
      const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    getLastItemOfDict: function (dict) {
      return dict[Object.keys(dict)[Object.keys(dict).length - 1]]
    },
    getNumberofDigits: function (number) {
      return Math.max(Math.floor(Math.log10(Math.abs(number))), 0) + 1
    },
    roundDigits: function (number, precision) {
      if (precision > 0) {
        return Math.round((Number(number) + Number.EPSILON) * (Math.pow(10, precision))) / (Math.pow(10, precision))
      }
      return Math.round(number)
    },
    showDigits: function (number, precision) {
      const factor = Math.pow(10, precision)
      return (Math.round(number * factor) / factor).toFixed(precision)
    },
    padLeft: function (num, size) {
      let s = num + ''
      while (s.length < size) {
        s = '0' + s
      }
      return s
    },
    getCoordinatesNautical: function (latDec, lngDec, precision = 6) {
      const latDir = (latDec > 0) ? 'N' : 'S'
      const lngDir = (lngDec > 0) ? 'E' : 'W'

      const lat = Math.abs(latDec)
      const lng = Math.abs(lngDec)

      const latDeg = Math.floor(lat)
      const lngDeg = Math.floor(lng)
      const latMin = (lat - latDeg) * 60
      const lngMin = (lng - lngDeg) * 60
      // var latSec = 3600 * (lat - latDeg) - 60 * latMin;
      // var lngSec = 3600 * (lng - lngDeg) - 60 * lngMin;
      const latStr = latDeg + '° ' + this.padLeft(latMin.toFixed(precision / 2), precision) + '\' ' + latDir // + Math.roundDigits(latSec, 2) + '\'\''
      const lngStr = lngDeg + '° ' + this.padLeft(lngMin.toFixed(precision / 2), precision) + '\' ' + lngDir // + Math.roundDigits(lngSec, 2) + '\'\''

      return { lat: latStr, lng: lngStr }
    },
    getDestination: function (start, heading, distance) {
      const R = 6378.137
      const lat1 = this.rad(start[0])
      const lng1 = this.rad(start[1])
      const bearing = this.rad(heading)
      const lat2 = Math.asin(Math.sin(lat1) * Math.cos(distance / R) + Math.cos(lat1) * Math.sin(distance / R) * Math.cos(bearing))
      let lng2 = lng1 + Math.atan2(Math.sin(bearing) * Math.sin(distance / R) * Math.cos(lat1), Math.cos(distance / R) - Math.sin(lat1) * Math.sin(lat2))
      lng2 = Math.fmod((lng2 + 3 * Math.PI), (2 * Math.PI)) - Math.PI
      return [this.deg(lat2), this.deg(lng2)]
    },
    // Get distance between to locations
    getDistance: function getDistance (p1, p2) {
      const R = 6378137
      const dLat = this.rad(p2.lat - p1.lat)
      const dLong = this.rad(p2.lng - p1.lng)
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.rad(p1.lat)) * Math.cos(this.rad(p2.lat)) *
        Math.sin(dLong / 2) * Math.sin(dLong / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c
    },
    getBearing: function getBearing (p1, p2) {
      const lat1 = p1.lat / 180 * Math.PI
      const lng1 = p1.lng / 180 * Math.PI
      const lat2 = p2.lat / 180 * Math.PI
      const lng2 = p2.lng / 180 * Math.PI
      const y = Math.sin(lng2 - lng1) * Math.cos(lat2)
      const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1)
      const theta = Math.atan2(y, x)
      return (theta * 180 / Math.PI + 360) % 360 // in degrees
    },
    compareCoordinates: function (position1, position2) {
      if (typeof position1 !== 'undefined' && typeof position2 !== 'undefined') {
        return Number(position1.lat) === Number(position2.lat) &&
          Number(position1.lng) === Number(position2.lng)
      }
      return false
    },
    wrapAngleDeg: function (angle) {
      return angle + (360 * Math.floor((180 - angle) / 360))
    },
    wrapLongitude: function (longitude) {
      return (longitude + 360) % 360
    },
    compareTimestamps: function (obj1, obj2) {
      if (obj1.timestamp_start < obj2.timestamp_start) {
        return 1
      } else {
        return -1
      }
    },
    getClosestValue: function (timestamp, values) {
      // Values contains elements with 0 = timestamp, 1 = value
      let mid
      let low = 0
      let high = values.length - 1
      while (high - low > 1) {
        mid = Math.floor((low + high) / 2)
        if (values[mid][0] < timestamp) {
          low = mid
        } else {
          high = mid
        }
      }
      if (timestamp - values[low][0] < values[high][0] - timestamp) {
        return values[low]
      }
      return values[high]
    },
    getClosestValueObject: function (timestamp, values) {
      // Values contains objects with ts = timestamp
      let mid
      let low = 0
      let high = values.length - 1
      while (high - low > 1) {
        mid = Math.floor((low + high) / 2)
        if (values[mid].ts < timestamp) {
          low = mid
        } else {
          high = mid
        }
      }
      if (timestamp - values[low].ts < values[high].ts - timestamp) {
        return values[low]
      }
      return values[high]
    },
    arrayEquals: function (a, b) {
      return Array.isArray(a) && Array.isArray(b) &&
        a.length === b.length && a.every((val, index) => val === b[index])
    },
    /**
     * Checks if an update (value and timestamp) is valid regarding its age
     * @param update - the update to be checked
     * @param parameter - the parameter that gets updated
     * @param maxAgeMs - maximum allowed data age in case the parameter timeout is not set
     * @returns {boolean} - true if valid, else false
     */
    updateAgeValid: function (update, parameter, maxAgeMs) {
      const maximumAllowedDataAge = (parameter.timeout !== 0) ? parameter.timeout : maxAgeMs
      return (Date.now() - update[0] <= maximumAllowedDataAge)
    }
  }
}
